import { render } from "./AnnexStepValidation.vue?vue&type=template&id=3226b4ea&ts=true"
import script from "./AnnexStepValidation.vue?vue&type=script&lang=ts"
export * from "./AnnexStepValidation.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./AnnexStepValidation.vue?vue&type=style&index=0&id=3226b4ea&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__